import React from 'react';
import s from './Filters.css';
import { Motion, spring } from 'react-motion';

class Filters extends React.Component {

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const filters = { ...this.props.filters, [e.target.name]: e.target.value };
    this.props.onFilter(filters);
  }

  render() {
    const { facets, filters, onFilterReset } = this.props;
    const renderer = () => {
      return Object.keys(facets).map((name) => {
        const fields = { _all: '', ...facets[name] };
        const inputs = Object.keys(fields).map((value) => {
          return (
            <label key={value}>
              <input
                type="radio"
                name={name}
                value={value}
                onChange={this.handleChange}
                checked={(filters[name] === value)}
              />
              {value}
              <Motion defaultStyle={{ x: 0 }} style={{ x: spring(fields[value]) }}>
                {v => <span>{Math.round(v.x)}</span>}
              </Motion>
            </label>
          );
        });

        return (
          <div key={name} className={`${s.section} ${s[name]}`}>
            {inputs}
          </div>
        );
      });
    };

    return (
      <div className={s.wrapper}>
        {/* <input type="button" onClick={onFilterReset} value="ALL" /> */}
        {renderer()}
      </div>
    );
  }
}

Filters.propTypes = {
  facets: React.PropTypes.object.isRequired,
  filters: React.PropTypes.object.isRequired,
  onFilter: React.PropTypes.func.isRequired,
  onFilterReset: React.PropTypes.func.isRequired,
};

export default Filters;



/** WEBPACK FOOTER **
 ** ./components/Products/Filters.js
 **/